import { getDebugMode } from "src/utils";
import { Css } from "~generated/css";

export function DebugModeBottomBanner() {
  if (!getDebugMode()) return null;

  return <div css={Css.z9999.absolute.bottom0.left("50%").bgRed600.white.$}>Debug Mode On</div>;
}
